import React, { useEffect, useMemo, useState } from 'react';
import appStoreBadge from '../../assets/badges/app-store-badge.png';
import googlePlayBadge from '../../assets/badges/google-play-badge.png';
import { getDevicePlatform } from '../../utils/devicePlatform';

const APP_STORE_URL = (process.env.REACT_APP_APP_STORE_URL || '').trim();
const PLAY_STORE_URL = (process.env.REACT_APP_PLAY_STORE_URL || '').trim();

const AppDownloadBanner: React.FC = () => {
  const [platform, setPlatform] = useState<'ios' | 'android' | 'other'>(
    'other',
  );

  useEffect(() => {
    setPlatform(getDevicePlatform());
  }, []);

  const storeLink = useMemo(() => {
    if (platform === 'ios' && APP_STORE_URL) {
      return {
        href: APP_STORE_URL,
        label: 'Download on the App Store',
        badge: appStoreBadge,
      };
    }

    if (platform === 'android' && PLAY_STORE_URL) {
      return {
        href: PLAY_STORE_URL,
        label: 'Get it on Google Play',
        badge: googlePlayBadge,
      };
    }

    return null;
  }, [platform]);

  if (!storeLink) {
    return null;
  }

  const { href, label, badge } = storeLink;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={label}
      aria-label={label}
      className="md:hidden inline-flex items-center shrink-0"
    >
      <img src={badge} alt={label} className="h-11 w-auto" />
    </a>
  );
};

export default AppDownloadBanner;
